const AUTH_RETURN_PATH_KEY = 'didge.authReturnPath'

const AUTH_PATHS = new Set([
  '/login',
  '/redirect',
  '/request-reset',
  '/reset-password',
])

export function buildReturnPath(location: {
  pathname: string
  search?: string
  hash?: string
}): string {
  return `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`
}

export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.has(pathname)
}

/** Persist the post-login destination across OAuth redirects and full page reloads. */
export function saveAuthReturnPath(location: {
  pathname: string
  search?: string
  hash?: string
}): void {
  if (isAuthPath(location.pathname)) {
    return
  }

  const path = buildReturnPath(location)
  if (path && path !== '/') {
    sessionStorage.setItem(AUTH_RETURN_PATH_KEY, path)
  }
}

export function consumeAuthReturnPath(): string | null {
  const path = sessionStorage.getItem(AUTH_RETURN_PATH_KEY)
  if (path) {
    sessionStorage.removeItem(AUTH_RETURN_PATH_KEY)
  }
  return path
}

export function resolveAuthReturnPath(
  fromLocation?: { pathname: string; search?: string; hash?: string } | null,
): string {
  if (fromLocation && !isAuthPath(fromLocation.pathname)) {
    sessionStorage.removeItem(AUTH_RETURN_PATH_KEY)
    return buildReturnPath(fromLocation)
  }

  return consumeAuthReturnPath() ?? '/'
}
